import { render, staticRenderFns } from "./IngresosCPage.vue?vue&type=template&id=1ebfa48b"
import script from "./IngresosCPage.js?vue&type=script&lang=js&external"
export * from "./IngresosCPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports